import React from 'react';
import {BrowserRouter, Routes, Route} from 'react-router-dom';
import './App.css';
import ScrollToTop from './ScrollToTop';
import Header from './Header';
import About from './About';
import Portfolio from './Portfolio';
import Music from './Music';
import Portalware from './Portalware';
import CrochetMatic from './CrochetMatic';
import SMSTFEditor from './SMSTFEditor';
import PathTracer from './PathTracer';
import SurfaceBrush from './SurfaceBrush';
import LeChat from './LeChat';
import Teapot from './Teapot';
import TileTunes from './TileTunes';
import DiscoBot from './DiscoBot';
import PVDCM from './PVDCM';
import WiCSHistory from './WiCSHistory';
import CoChair from './CoChair';

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
          <Route path="/" element={<><Header page={0}/><About /></>} />
          <Route path="/work" element={<><Header page={1}/><Portfolio /></>} />
          <Route path="/music" element={<>
            <Header page={1}/>
            <Music />
          </>} />
          <Route path="/cochair" element={<>
            <Header page={2}/>
            <CoChair />
          </>} />
          <Route path="/portalware" element={<>
            <Header page={2}/>
            <Portalware />
          </>} />
          <Route path="/crochetmatic" element={<>
            <Header page={2}/>
            <CrochetMatic />
          </>} />
          <Route path="/smstfeditor" element={<>
            <Header page={2}/>
            <SMSTFEditor />
          </>} />
          <Route path="/pathtracer" element={<>
            <Header page={2}/>
            <PathTracer />
          </>} />
          <Route path="/surfacebrush" element={<>
            <Header page={2}/>
            <SurfaceBrush />
          </>} />
          <Route path="/lechat" element={<>
            <Header page={2}/>
            <LeChat />
          </>} />
          <Route path="/teapot" element={<>
            <Header page={2}/>
            <Teapot />
          </>} />
          <Route path="/tiletunes" element={<>
            <Header page={2}/>
            <TileTunes />
          </>} />
          <Route path="/discobot" element={<>
            <Header page={2}/>
            <DiscoBot />
          </>} />
          <Route path="/pvdcm" element={<>
            <Header page={2}/>
            <PVDCM />
          </>} />
          <Route path="/wicshistory" element={<>
            <Header page={2}/>
            <WiCSHistory />
          </>} />
        </Routes>
    </BrowserRouter>
  );
}

export default App;
